import React from "react";
import { FabProps } from "@material-ui/core/Fab";

import { Content } from "./Content";
import { BaseHero } from "../../common";
import { useBusinessMainImage, useBusinessUnitName } from "../../hooks";

interface DefaultHeroProps {
  primaryButton?: FabProps;
  secondaryButton?: FabProps;
}

export const DefaultHeroLayout: React.FC<DefaultHeroProps> = ({ children }) => {
  const mainImageUrl = useBusinessMainImage();
  const businessUnitName = useBusinessUnitName();

  return (
    <BaseHero>
      <Content businessUnitName={businessUnitName} businessUnitImage={mainImageUrl}>
        {children}
      </Content>
    </BaseHero>
  );
};
